import { PropsWithChildren } from "react";
import { Container, type ContainerProps } from "@chakra-ui/react";

function PageContent({ children, ...props }: PropsWithChildren | ContainerProps) {
  return (
    <Container maxW={{ sm: "7xl", "2xl": "8xl"}} px={4} pb={16} {...props}>{children}</Container>
  );
}

export default PageContent;
